import { Component, OnInit } from '@angular/core';
import { FlashController } from '../../../flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-ath-pinpad',
  templateUrl: './ath-pinpad.component.html',
  styleUrls: ['./ath-pinpad.component.sass']
})
export class AthPinpadComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
